import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea';
import ResponseMsg2 from '../../general/ResponseMsg2';
import axios from 'axios';
import { FaCheck } from 'react-icons/fa';

const ExamType = ({ setLoading }) => {
    const [isAverageExam, setIsAverageExam] = useState(false);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [exam, setExam] = useState([]);
     const [searchTerm, setSearchTerm] = useState('');

    const [form, setForm] = useState({
        examName: '',
        examStatus: true,
        averageMarks: '',
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: value
        })
    }

    // const handleToggleAverageExam = () => {
    //     setForm((prevForm) => ({
    //         ...prevForm,
    //         examStatus: prevForm.examStatus === 'Yes' ? 'No' : 'Yes',
    //     }));
    // };


    const handleSubmit = async (e) => {
        console.log('function call')
        e.preventDefault();

        setLoading(true);

        const payload = {
            ...form,
            examStatus: form.examStatus ? 'Yes' : 'No'
        }

        try {
            const response = await axios.post(
                'https://api.kcian.in/add-exam-type', payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            fetchDetail();

            setResponse2({
                message: 'Exam Type Added.',
                status: 'success'
            });
            setForm({
                examName: '',
                examStatus: true,
                averageMarks: '',
            });


            setTimeout(() => {
                setResponse2('');
            }, 2000);

            setLoading(false);
        } catch (error) {
            console.error('Error submitting form:', error);
            setResponse2({ message: 'Server error. Please try again later.', status: 'error' });
            setTimeout(() => {
                setResponse2('');
            }, 2000);
            setLoading(false);
        }
    };



    const fetchDetail = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.kcian.in/fetch-exam');
            setExam(res.data);
            console.log(res.data);
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchDetail();

    }, [])


    
    const filterExam = exam.filter(tt => {
        const term = searchTerm.toLowerCase();
        return (
            tt.exam_name.toLowerCase().includes(term) ||
            tt.average_status.toLowerCase().includes(term) 
         
            
           
        );
    });

    return (
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1="Exam" message2="Exam Type" />

                        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
                <div className='row'>
                    <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                        <div className="profile-card">
                            <p className="profile-heading">Add Exam Type</p>
                            <form className='mt-4' onSubmit={handleSubmit} >
                                <div className="mb-4">
                                    {/* Exam Name */}
                                    <div className='profile-input-area'>
                                        <label className='profile-badge'>Exam Name</label>
                                        <input className='profile-input' type='text'
                                            name='examName'
                                            value={form.examName}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/* Toggle */}
                                

                                    {/* <div className='profile-input-area mt-4'>
                                        <p className='m-2'>Average Passing Examination</p>
                                        <div className="form-check form-switch mt-4 mx-3">

                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="switchCheckDefault"
                                                checked={form.examStatus}
                                                onChange={() =>
                                                    setForm((prev) => ({
                                                        ...prev,
                                                        examStatus: !prev.examStatus, // toggle boolean
                                                    }))
                                                }
                                            />
                                            <label className="form-check-label" htmlFor="switchCheckDefault">
                                                {form.examStatus ? "Yes" : "No"}
                                            </label>

                                        </div>
                                    </div> */}



                                    {form.examStatus && (
                                        <div className='profile-input-area mt-4'>
                                            <label className='profile-badge'>Average mark</label>
                                            <input
                                                name='averageMarks'
                                                value={form.averageMarks}
                                                onChange={(e) =>
                                                    setForm((prev) => ({
                                                        ...prev,
                                                        averageMarks: e.target.value,
                                                    }))
                                                }
                                                className='profile-input'
                                                type='number'
                                            />
                                        </div>
                                    )}

                                </div>

                                {/* Buttons */}
                  <div className="text-center">
                                    <button className="profile-btn" type="submit">
                                        <FaCheck /> Save 
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Right side */}
                    <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                        <div className='profile-card'>
                            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                <span className="profile-heading align-content-center">Exam Type List</span>

                                <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                    <input
                                        type='text'
                                        name='search'
                                        className='profile-input border-bottom rounded-0'
                                        placeholder='Search by Exam Type'
                                         value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className='table-responsive'>
                                <table className='w-100 text-center'>
                                    <thead className='account-thead'>
                                            <th className='rounded-start-4'>S No</th>
                                            <th>Type</th>
                                            <th>Is Average Passing Exam</th>
                                            <th className='rounded-end-4'>Average Marks</th>
                                            {/* <th className='rounded-end-4'>Action</th> */}
                                    </thead>
                                  
                                    <tbody>
                                        {filterExam.length > 0 ? (
                                            filterExam.map((data, id) => (
                                                <tr key={id}className='account-tr'>
                                                    <td>{id + 1}</td>
                                                    <td> {data.exam_name}  </td>
                                                    <td>{data.average_status}  </td>
                                                    <td>{data.average_marks}   </td>
                                                   

                                                </tr>
                                            ))) :
                                            <tr className='account-tr text-center'>
                                                <td colSpan="6">
                                                    No Data found.
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ExamType
